import { render, staticRenderFns } from "./PlainCard.vue?vue&type=template&id=63ab7027&scoped=true&"
import script from "./PlainCard.vue?vue&type=script&lang=js&"
export * from "./PlainCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab7027",
  null
  
)

export default component.exports